import { render, staticRenderFns } from "./UserPhoneStatus.vue?vue&type=template&id=6dfd5ca7&"
import script from "./UserPhoneStatus.vue?vue&type=script&lang=js&"
export * from "./UserPhoneStatus.vue?vue&type=script&lang=js&"
import style0 from "./UserPhoneStatus.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports